import axios from "axios";
import cart from "@/parts/Front/components/cart/cart";
import { getCookie, checkRequest } from "@/libraries/VueMethods";

export default {
  async getMenu({ commit }, key) {
    await axios.get(`/all/menus/${key}`).then((res) => {
      commit("setMenu", { key: key, value: res.data.data.menus });
    });
  },
  async getMainContent({ commit }, { route }) {
    let key = null;
    let caseFlag = true;
    if (route.startsWith("get")) {
      caseFlag = false;
      key = route.split("-")[1];
    } else {
      caseFlag = true;
      key = route;
    }
    if (checkRequest(`/front/${caseFlag ? route.toLowerCase() : route}`)) return;
    await axios
      .get(`/front/${caseFlag ? route.toLowerCase() : route}`, {
        params: key == "user" ? { ...cart.getCartRequestQueryString() } : {},
      })
      .then((res) => {
        let result = res.data;
        if (route == "get-settings") {
          let settingGroups = {};
          result.forEach((setting) => {
            if (!settingGroups[setting.group]) {
              settingGroups[setting.group] = {};
            }
            settingGroups[setting.group][setting.name] = setting.value;
          });
          result = settingGroups;
        }
        if (key == "user") {
          if (result.user) {
            commit("setLoginStatus", result.user);
          } else {
            commit("setLoginStatus", false);
          }
          if (result.user) {
            result.cart = new cart(this._vm, result.cart, "server");
          } else {
            console.log("cookie mode");
            let initialCarts = cart.getInitialCartForCookieMode(
              result.cartRequest
            );
            result.cart = new cart(this._vm, initialCarts, "cookie");
          }
        }
        commit("setMainContent", {
          key: key,
          value: result,
        });
      });
  },
  async addToCart({ state }, payLoad) {
    let variety = payLoad.variety;
    let product = payLoad.product;
    let quantity = payLoad.quantity;
    let cart = state.mainContent.user.cart;
    if (cart.mode == "server") {
      const response = await axios.post(`customer/cart/add/${variety.id}`, {
        quantity: quantity,
      });
      let cartItem = response.data.data.cart;
      cart.addToCart(cartItem);
      return response;
    } else {
      // It may throw an error with message "NO_STOCK"
      state.mainContent.user.cart.addFakeChart(variety, quantity, product);
      return {
        data: {
          message: "محصول با موفقیت به سبد خرید اضافه شد",
        },
      };
    }
  },
  async deleteCart({ state }, cartItem) {
    let cart = state.mainContent.user.cart;
    if (cart.mode == "server") {
      const response = await axios.delete(`customer/cart/${cartItem.id}`);
      cart.deleteCart(cartItem);
      return response;
    } else {
      cart.deleteCart(cartItem);
      return {
        data: {
          message: "محصول با موفقیت از سبد خرید حذف شد",
        },
      };
    }
  },
  async incrementCart({ state, dispatch }, cartItem) {
    return dispatch("changeCartQuantity", {
      cartItem: cartItem,
      newQuantity: cartItem.quantity + 1,
    });
  },
  async decrementCart({ state, dispatch }, cartItem) {
    return dispatch("changeCartQuantity", {
      cartItem: cartItem,
      newQuantity: cartItem.quantity - 1,
    });
  },
  async changeCartQuantity({ state }, { cartItem, newQuantity }) {
    let message =
      newQuantity > cartItem.quantity
        ? "محصول با موفقیت به سبد خرید شما اضافه شد"
        : "محصول با موفقیت از سبد خرید کم شد";
    if (newQuantity == 0) {
      throw new Error("ZERO");
    } else if (newQuantity > cartItem.variety.quantity) {
      throw new Error("NO_STOCK");
    }
    let cart = state.mainContent.user.cart;
    let response;
    if (cart.mode === "server") {
      response = await this._vm.$axios.post(`customer/cart/${cartItem.id}`, {
        quantity: newQuantity,
        _method: "put",
      });
    } else {
      response = {
        data: {
          message: message,
        },
      };
    }
    cart.setCartQuantity(cartItem, newQuantity);

    return response;
  },
};
